module.exports = __webpack_public_path__ + "img/letraG.20736297.png";